import apiClient from '../axios.js';

/**
 * 隱私權政策管理 API
 */
export const policyService = {
  /**
   * 獲取隱私權政策列表
   * @param {Object} params - 查詢參數
   * @param {number} params.page - 頁碼
   * @param {number} params.pageSize - 每頁數量
   * @param {string} params.search - 搜尋關鍵字
   * @param {string} params.status - 狀態 (draft, published, archived)
   * @param {string} params.language - 語言代碼
   * @param {string} params.sortBy - 排序欄位
   * @param {string} params.order - 排序方向
   * @returns {Promise<Object>} 隱私權政策列表
   */
  getPolicies: async (params = {}) => {
    const response = await apiClient.get('/policies', { params });
    return response;
  },

  /**
   * 獲取當前生效的隱私權政策
   * @param {string} language - 語言代碼（選填，預設 'zh-TW'）
   * @returns {Promise<Object>} 當前生效的隱私權政策
   */
  getCurrent: async (language = 'zh-TW') => {
    const response = await apiClient.get('/policies/current', {
      params: { language }
    });
    return response;
  },

  /**
   * 獲取單一隱私權政策詳情
   * @param {string} id - 隱私權政策 ID
   * @returns {Promise<Object>} 隱私權政策詳情
   */
  getPolicy: async (id) => {
    const response = await apiClient.get(`/policies/${id}`);
    return response;
  },

  /**
   * 新增隱私權政策
   * @param {Object} policyData - 隱私權政策資料
   * @param {string} policyData.version - 版本號
   * @param {string} policyData.title - 標題
   * @param {string} policyData.content - 內容
   * @param {string} policyData.language - 語言代碼（選填，預設 'zh-TW'）
   * @param {string} policyData.status - 狀態（選填，預設 'draft'）
   * @param {string} policyData.effectiveDate - 生效日期 (YYYY-MM-DD)
   * @returns {Promise<Object>} 新增結果
   */
  createPolicy: async (policyData) => {
    const response = await apiClient.post('/policies', policyData);
    return response;
  },

  /**
   * 更新隱私權政策
   * @param {string} id - 隱私權政策 ID
   * @param {Object} policyData - 隱私權政策資料
   * @returns {Promise<Object>} 更新結果
   */
  updatePolicy: async (id, policyData) => {
    const response = await apiClient.put(`/policies/${id}`, policyData);
    return response;
  },

  /**
   * 發布隱私權政策
   * @param {string} id - 隱私權政策 ID
   * @returns {Promise<Object>} 發布結果
   */
  publishPolicy: async (id) => {
    const response = await apiClient.post(`/policies/${id}/publish`);
    return response;
  },

  /**
   * 刪除隱私權政策
   * @param {string} id - 隱私權政策 ID
   * @returns {Promise<Object>} 刪除結果
   */
  deletePolicy: async (id) => {
    const response = await apiClient.delete(`/policies/${id}`);
    return response;
  },
};
